{
  "it": {
    "window": {
      "app": "App",
      "customersDashboard": "Dashboard",
      "customersDecisionDocuments": "Decisione",
      "customersDecisionProposals": "Proposte di decisione",
      "customersDecisionTickets": "Decisione",
      "customersDecisionTicketsShow": "Decisione",
      "customersDecisions": "Decisioni",
      "customersDocuments": "Documenti",
      "customersDocumentsAll": "Panoramica documenti",
      "customersDocumentsFolder": "Categoria documento",
      "customersDocumentsFolders": "Categorie documento",
      "customersInspirationLists": "Ispirazioni",
      "customersInspirationListsShow": "Ispirazioni",
      "customersInstallmentTerms": "Rate",
      "customersIssues": "Post-vendita",
      "customersIssuesList": "Post-vendita",
      "customersProjectInformation": "Informazioni progetto",
      "customersQuestionLists": "FAQ",
      "customersQuestionListsShow": "FAQ",
      "customersRoot": "Dashboard",
      "customersRootSettingsProfile": "Impostazioni",
      "customersSettingsProfile": "Impostazioni",
      "customersTickets": "Conversazioni",
      "customersTicketsNew": "Nuova conversazione",
      "customersTicketsShow": "Conversazione",
      "employeesClientContacts": "Contatti",
      "employeesClientContactsNew": "Nuovo contatto",
      "employeesClientContactsNewCustomer": "Nuovo cliente",
      "employeesClientContactsNewPartner": "Nuovo partner",
      "employeesClientContactsType": "Contatti",
      "employeesClientDashboard": "Dashboard",
      "employeesClientProjects": "Progetti",
      "employeesClientProjectsNew": "Nuovo progetto",
      "employeesClientTickets": "Conversazioni",
      "employeesClientTicketsNew": "Nuova conversazione",
      "employeesClientTicketsShow": "Conversazione",
      "employeesMarketplace": "Mercato",
      "employeesProjectActivity": "Cronologia",
      "employeesProjectAnnouncements": "Novità",
      "employeesProjectDecisionActivity": "Cronologia",
      "employeesProjectDecisionDocuments": "Decisione",
      "employeesProjectDecisionProposalTemplate": "Modelli di proposta",
      "employeesProjectDecisionProposals": "Proposte",
      "employeesProjectDecisionReminders": "Promemoria",
      "employeesProjectDecisionTickets": "Conversazioni",
      "employeesProjectDecisionTicketsShow": "Conversazione",
      "employeesProjectDecisionTypeNew": "Nuova decisione",
      "employeesProjectDecisionTypes": "Decisioni",
      "employeesProjectDecisions": "Decisioni",
      "employeesProjectDecisionsEdit": "Decisioni",
      "employeesProjectDecisionsNew": "Nuova decisione",
      "employeesProjectDocuments": "Documenti",
      "employeesProjectInformationPageActivity": "Cronologia",
      "employeesProjectInformationPageAftercare": "Post-vendita",
      "employeesProjectInformationPageDecisions": "Decisioni",
      "employeesProjectInformationPageDocuments": "Documenti",
      "employeesProjectInformationPageInformation": "Informazioni",
      "employeesProjectInformationPageInstallments": "Rate",
      "employeesProjectInformationPageLevels": "Livelli",
      "employeesProjectInformationPageMilestones": "Tappe",
      "employeesProjectInformationPageSpaces": "Pertinenze",
      "employeesProjectInformationPageSurveys": "Questionari",
      "employeesProjectInformationPageTaskAssignments": "Attività",
      "employeesProjectInformationPageTasks": "Attività",
      "employeesProjectInformationPageTickets": "Conversazioni",
      "employeesProjectInstallmentGroup": "Finanze",
      "employeesProjectInstallmentGroupNew": "Nuovo gruppo di rate",
      "employeesProjectInstallmentGroups": "Finanze",
      "employeesProjectInstallmentGroupsList": "Finanze",
      "employeesProjectInstallmentGroupsMatrix": "Rate",
      "employeesProjectInstallmentNew": "Nuove rate",
      "employeesProjectIssueListTypeIssues": "Elenco segnalazioni - Tutte le segnalazioni",
      "employeesProjectIssueListTypeNew": "Nuovo elenco segnalazioni",
      "employeesProjectIssueListTypeUnits": "Elenco segnalazioni - Panoramica unità",
      "employeesProjectIssueListTypes": "Elenchi segnalazioni",
      "employeesProjectIssueListUnitDocuments": "Segnalazioni unità - Documenti",
      "employeesProjectIssueListUnitIssues": "Segnalazioni unità",
      "employeesProjectIssueListUnitTickets": "Segnalazioni unità - Conversazioni",
      "employeesProjectIssueListUnitTicketsShow": "Conversazioni",
      "employeesProjectIssueListsNew": "Nuove segnalazioni",
      "employeesProjectMilestones": "Tappe",
      "employeesProjectQuestionLists": "FAQ",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Vendite",
      "employeesProjectSurveySummary": "Questionario",
      "employeesProjectSurveyTypes": "Questionari",
      "employeesProjectSurveys": "Questionario",
      "employeesProjectTasks": "Attività",
      "employeesProjectTickets": "Conversazioni",
      "employeesProjectTicketsEmailConversations": "Email",
      "employeesProjectTicketsEmailConversationsShow": "Email",
      "employeesProjectTicketsNew": "Nuova conversazione",
      "employeesProjectTicketsShow": "Conversazioni",
      "employeesProjectTodoLists": "Attività",
      "employeesSettingsClientAftercare": "Post-vendita",
      "employeesSettingsClientInformation": "Amministrazione",
      "employeesSettingsClientIntegrations": "Integrazioni",
      "employeesSettingsProfile": "Profilo",
      "level": "Livello",
      "mployeesProjectInstallmentGroups": "Finanze",
      "partnersClientProjects": "Progetti",
      "partnersProjectDecisionDocuments": "Documenti",
      "partnersProjectDecisionProposals": "Proposte",
      "partnersProjectDecisionTickets": "Conversazioni",
      "partnersProjectDecisionTicketsShow": "Conversazione",
      "partnersProjectDecisionTypesItems": "Decisioni",
      "partnersProjectDecisions": "Decisioni",
      "partnersProjectDocuments": "Documenti",
      "partnersProjectDocumentsUnit": "Documenti",
      "partnersProjectIssueListTypeIssues": "Elenco segnalazioni - Tutte le segnalazioni",
      "partnersProjectIssueListTypeUnits": "Elenco segnalazioni - Panoramica unità",
      "partnersProjectIssueListTypes": "Post-vendita",
      "partnersProjectIssueListUnitDocuments": "Segnalazioni unità - Documenti",
      "partnersProjectIssueListUnitIssues": "Segnalazioni unità",
      "partnersProjectIssueListUnitTickets": "Segnalazioni unità - Conversazioni",
      "partnersSettingsProfile": "Profilo",
      "root": "App"
    }
  }
}
